import { createTheme, Theme } from '@material-ui/core/styles';
import { breakpoints } from './breakpoints';
import { visionColor } from './color';
import { palette } from './palette';

export const visionTheme: Theme = createTheme({
  breakpoints: {
    values: breakpoints,
  },
  palette: {
    primary: {
      main: visionColor.primary,
      300: visionColor.primary300,
      500: visionColor.primary500,
      700: visionColor.primary700,
    },
    secondary: {
      main: visionColor.secondary,
    },
    error: {
      main: visionColor.danger,
    },
    warning: {
      main: visionColor.warning,
    },
    info: {
      main: visionColor.info,
    },
    success: {
      main: visionColor.success,
    },
    grey: {
      100: palette.gray100,
      200: palette.gray200,
      300: palette.gray300,
      400: palette.gray400,
      500: palette.gray500,
      600: palette.gray600,
      700: palette.gray700,
      800: palette.gray800,
      900: palette.gray900,
    },
    text: {
      primary: visionColor.bodyColor,
    },
    background: {
      default: palette.gray200,
    },
  },
  props: {
    MuiGrid: {
      xs: 12,
    },
  },
});
